export default __webpack_public_path__ + "static/14 - Kötődoboz-bff94bb309bcbda1561e0654ae648af0.jpg";